// extracted by mini-css-extract-plugin
export default {"quantity-picker":"ALMQp","quantityPicker":"ALMQp","button":"J7ZxB","counter":"Afoii","disabled":"Me5nK"};